import { mapGetters } from "vuex";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import announcements from "@/frame/messages/mixins/announcements.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";

export default {
  computed: {
    ...mapGetters(["getCurrentPage", "getUserAccessList", "getUser"])
  },
  props: { data: { type: Object } },
  components: { BtnSpin },
  // eslint-disable-next-line
  mixins: [
    apptheme,
    docLogFunctions,
    createFirebase,
    getList,
    listFunctions,
    announcements,
    generateID
  ],
  methods: {
    openDialog() {
      this.btnSpinAccessRequest = false;
    },
    closeDialog() {
      this.dialog = false;
    },
    requestAccess(detail) {
      this.showRequestBtn = false;
      console.log("ACCESS REQUEST");
      console.log(detail);
      // defined tag and based on tag generated different access
      let tag = detail.basic.tag;
      let didAccess = this.generateDID("DATE", "G1");
      // update local data
      if (tag === "C1") {
        // console.log("COMPANY ACCESS REQUEST");
        // company user register
        this.createFirebaseDocumentAccess(detail, "G1", "C1", "U1", didAccess);
        // user access company
        this.createFirebaseDocumentAccess(detail, "G1", "U1", "C1", didAccess);
        // user access update
        // this.changeFirebaseStatsRemote("U1", "stats.nc1a", 1);
        // USER Log
        let udid = this.getUser.basic.did;
        // eslint-disable-next-line
        let log = this.generateLog("U1", "Company Access", "was requested.", detail);
        this.$store.dispatch("changeUserDID", udid);
        this.createFirebaseDocumentLog("U1", log);
      } else {
        // company user register
        this.createFirebaseDocumentAccess(detail, "G1", "F1", "U1", didAccess);
        // user access company
        this.createFirebaseDocumentAccess(detail, "G1", "U1", "F1", didAccess);
        // user access update
        // this.changeFirebaseStatsRemote("U1", "stats.nf1a", 1);
        // USER Log
        let udid = this.getUser.basic.did;
        // eslint-disable-next-line
        let log = this.generateLog("U1", "Facility Access", "was requested.", detail);
        this.$store.dispatch("changeUserDID", udid);
        this.createFirebaseDocumentLog("U1", log);
      }
      this.btnSpinAccessRequest = false;
    },
    verifyThenRequestAccess(detail) {
      // this.dialog = false;
      this.btnSpinAccessRequest = true;
      let did = detail.basic.did;
      // eslint-disable-next-line
      let duplicate = this.checkUserAccessDuplicate(did, this.getUserAccessList);
      // GET ACCESS
      if (duplicate === true) {
        this.btnSpinAccessRequest = false;
        this.dialog = false;
        // MESSAGE
        this.generateAccessRequestMesage(detail, " is being reviewed.");
      } else {
        // eslint-disable-next-line
        this.requestAccess(detail);
        // MESSAGE;
        this.generateAccessRequestMesage(detail, " was requested.");
      }
    },
    generateAccessRequestMesage(detail, txt) {
      let tag = detail.basic.tag;
      let msg = null;
      // msg = msg + this.displayDocumentIDGTypeA(tag, detail.basic.idg);
      if (tag === "C1") {
        msg = "Access Approval ";
        msg = msg + " for Company " + detail.basic.title;
      } else if (tag === "F1") {
        msg = "Access Approval ";
        msg = msg + " for Facility " + detail.basic.title;
      } else {
        msg = "Undefined";
      }
      msg = msg + txt;
      this.generateInfoSnackbar(this.ui.colorBlue1, msg);
    }
  },
  data() {
    return {
      valid: false,
      showRequestBtn: true,
      btnSpinAccessRequest: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  }
};
